import React, { useState } from "react";

import { DetectarTela } from "../../utils/detectarTamanhoTela";
import { useTranslation } from "react-i18next";

import BR from "../../utils/IMG/BANDEIRAS/br.png";
import ES from "../../utils/IMG/BANDEIRAS/es.png";
import EUA from "../../utils/IMG/BANDEIRAS/us.jpg";

import LOGO from "../../utils/SVG/LOGO.svg";
import WHATSAPP from "../../utils/SVG/whatsapp.svg"

import "./index.scss";

const Header = () => {
  const { t, i18n } = useTranslation();

  const LINGUAGENS = [
    {
      linguagem: "pt",
      nome: "Português Brasil",
      imagem: BR,
    },
    {
      linguagem: "es",
      nome: "Espanhol",
      imagem: ES,
    },
    {
      linguagem: "en",
      nome: "Inglês",
      imagem: EUA,
    },
  ];

  const [menuLinguagem, setMenuLinguagem] = useState(false);
  const [linguagemSelecionada, setLinguagemSelecionada] = useState(
    LINGUAGENS[0]
  );

  const selecionarLinguagem = (langSelecionada) => {
    i18n.changeLanguage(langSelecionada?.linguagem);
    setLinguagemSelecionada(langSelecionada);
    setMenuLinguagem(false);    
  };

  const abrirLinguagem = () => {
    setMenuLinguagem(!menuLinguagem);        
  }

  document.addEventListener("click", function (event) {
    var div = document.querySelector("#LangDiv");
    if (!div.contains(event.target)) {
      setMenuLinguagem(false);
    }
  });

 const direcionarDiv = (id) => {
  const target = document.getElementById(id);
  if (target) {
    target.scrollIntoView({ behavior: 'smooth' });
  }
};

   const EnviarMensagemWhatsApp = ({ children }) => {
    const whatsappNumber = "5527996676885";
    const message = encodeURIComponent(
      "Olá, gostaria de mais informações sobre seus serviços!"
    );
    const whatsappLink = `https://wa.me/${whatsappNumber}?text=${message}`;
    return (
      <a
        style={{ width: "fit-content", textDecoration:"none" }}
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        title="Converse conosco pelo WhatsApp!"
      >
        {children}
      </a>
    );
  };

  return (
    <div className="Header">
      <div className="container">
        <div className="barra">
          <div
            className="logo"
            style={{ backgroundImage: `url(${LOGO})` }}
            onClick={() => direcionarDiv("home")}
          />
        </div>
        <div className="menu-itens" style={{ alignItems:"center"}}>
          {!DetectarTela() && (
            <>
              <div className="item" onClick={() => direcionarDiv("sobre-nos")}>
                {t('sobre_nos.titulo')}
              </div>
              <div
                className="item"
                onClick={() => direcionarDiv("onde-atuamos")}
              >
                {t('onde_atuamos.titulo')}
              </div>
              {/* <div
                className="item"
                onClick={() => direcionarDiv("onde-estamos")}
              >
                Onde Estamos
              </div> */}
              <div className="item" onClick={() => direcionarDiv("contato")}>
                 {t('contato.titulo')}
              </div>
            </>
          )}
          <EnviarMensagemWhatsApp>
            <div style={{display:'flex', flexDirection:"row", alignItems:"center", gap:"10px"}}>
            <div style={{ 
              backgroundImage:`url(${WHATSAPP})`,
              width:"1.2rem", height:"1.2rem", backgroundPosition:"center", backgroundRepeat:"no-repeat", backgroundSize:"cover", fill:"red"}}
               />
               <div className="item">
                WhatsApp
              </div>
            </div>
          </EnviarMensagemWhatsApp>
          <div className="linguagem" id="LangDiv">
            <div
              className="bandeira"
              style={{
                backgroundImage: `url(${linguagemSelecionada?.imagem})`,
              }}
              title={linguagemSelecionada?.nome}
              onClick={() => abrirLinguagem()}
            />
            {menuLinguagem && (
              <div className="menu-linguagem" style={{zIndex:'99'}}>
                {LINGUAGENS?.map((lang, index) => {
                  return (
                    <div
                      className="bandeira"
                      id={index}
                      key={`LINGUAGENS${index}`}
                      title={lang?.nome}
                      style={{ backgroundImage: `url(${lang?.imagem})` }}
                      onClick={() => selecionarLinguagem(lang)}
                    />
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
